<div class="mx-auto px-4 pb-20 max-w-4xl">

  @if(notFound) {
  <div class="text-center py-20 bg-gray-50 rounded-xl border border-dashed border-gray-300 mt-6">
    <p class="text-gray-500">This phase could not be found.</p>
    <button (click)="goToProject()"
      class="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
      Back to project
    </button>
  </div>
  }

  @else if(loading) {
  <div class="animate-pulse space-y-4 mt-6">
    <div class="h-8 bg-gray-200 rounded w-1/3"></div>
    <div class="h-64 bg-gray-200 rounded-2xl"></div>
  </div>
  }

  @else if(project && stage) {
  <!-- Breadcrumb -->
  <div class="flex items-center gap-1.5 mt-5 mb-3 flex-wrap">
    <button (click)="goToProject()"
      class="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-gray-700 transition-colors cursor-pointer group">
      <svg class="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      {{ project.projectName }}
    </button>
    <span class="text-gray-300">›</span>
    <span class="text-sm text-gray-400">{{ stage.stageName }}</span>
    <span class="text-gray-300">›</span>
    <span class="text-sm font-medium text-gray-700">New task</span>
  </div>

  <div class="mb-5">
    <h1 class="text-2xl font-bold text-gray-900">New task</h1>
    <p class="text-sm text-gray-500 mt-1">In phase {{ stage.stageName }}</p>
  </div>

  <app-add-task presentation="page" [projectStageId]="stageId"
    [stageStartDate]="stage.startDate || undefined" [stageEndDate]="stage.endDate || undefined"
    [projectTenantId]="project.tenantId" [employees]="employees"
    (close)="goToProject()">
  </app-add-task>
  }
</div>
